import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Input from '@tds/core-input';
import Button from '@tds/core-button';
import DimpleDivider from '@tds/core-dimple-divider';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import ConfirmationBox from '../../../design/shared/ConfirmationBox';

const SendContractToModal = ({
  contractRecipient,
  setRecipient,
  setContractRecipient,
  setIsModalOpen
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      emailDetail: {
        contractAddress,
        contractAddressDetail,
        CCEmailAddress,
        CCEmailAddressDetail
      }
    },
    assigneeSRTModal: { addButton }
  } = localizedStrings;

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <ConfirmationBox header="Add Recipients" open setOpen={closeModal}>
      <div style={{ marginTop: '2rem' }}>
        <Box between={3}>
          <Input
            label={contractAddress}
            hintPosition="below"
            hint={contractAddressDetail}
            value={contractRecipient.to}
            onChange={e =>
              setContractRecipient({ ...contractRecipient, to: e.target.value })
            }
          />
          <Input
            label={CCEmailAddress}
            hintPosition="below"
            hint={CCEmailAddressDetail}
            value={contractRecipient.cc}
            onChange={e =>
              setContractRecipient({ ...contractRecipient, cc: e.target.value })
            }
          />
        </Box>
        <DimpleDivider />
        <Button onClick={setRecipient}>{addButton}</Button>
      </div>
    </ConfirmationBox>
  );
};

SendContractToModal.propTypes = {
  setIsModalOpen: PropTypes.func.isRequired,
  setRecipient: PropTypes.func.isRequired,
  setContractRecipient: PropTypes.func.isRequired,
  contractRecipient: PropTypes.shape({
    to: PropTypes.string,
    cc: PropTypes.string
  }).isRequired
};

export default SendContractToModal;
